/* eslint-disable */
<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-form ref="form" lazy-validation>
      <v-layout align-center justify-center wrap>
        <v-flex xs12 md4>
          <v-text-field
            box
            required
            label="Nome"
            :rules="[(v) => !!v || 'O nome é obrigatório!']"
            v-model="approach.name"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3 lg4>
          <v-select
            box
            label="Credor"
            item-text="name"
            item-value="creditor_id"
            :items="creditors.objects"
            :rules="[(v) => !!v || 'O credor é obrigatório!']"
            v-model="approach.creditor_id"
            disabled
          ></v-select>
        </v-flex>
        <v-flex xs12 md3>
          <v-select
            box
            clearable
            item-text="name"
            item-value="value"
            label="Tipo de notificação"
            :items="notifyTypes"
            :rules="[(v) => !!v || 'O tipo de notificação é obrigatório!']"
            v-model="approach.notify_type"
          >
            <v-tooltip top slot="prepend-inner">
              <template v-slot:activator="{ on }">
                <v-icon
                  class="pr-1"
                  style="font-size: 18px; cursor: help; height: 24px; width: 24px"
                  v-on="on"
                  >help</v-icon
                >
              </template>
              <ul>
                <li>
                  <b>Sequencial:</b> Cada contato recebe a mensagem seguinte da abordagem
                  (padrão)
                </li>
                <li>
                  <b>Aleatória:</b> As mensagens são distribuídas de forma aleatória entre
                  os contatos
                </li>
              </ul>
            </v-tooltip>
          </v-select>
        </v-flex>
        <v-flex xs12 md2 lg1>
          <v-btn block large style="margin-bottom: 35px" @click="save()">Salvar</v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout align-center justify-center wrap>
      <!--SMS-->
      <v-flex
        xs12
        :class="!messages.length ? '' : 'mb-4'"
        v-if="approach.type == 'SMS' || approach.type == 'SMS_FLASH'"
      >
        <h2 v-if="!messages.length" class="text-xs-center font-weight-regular">
          Nenhum SMS cadastrado.
        </h2>
        <v-list three-line subheader>
          <v-list-tile
            v-for="(item, index) in messages"
            :key="index"
            class="item-content"
          >
            <v-list-tile-content>
              {{ item.content }}

              <div v-if="item.offer_type" class="item-offer-type">
                Tipo da Oferta:
                <span class="item-offer-type-description">
                  {{ item.offer_type.description }}
                </span>
              </div>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn ripple icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(menu, i) in menuItens"
                    :key="i"
                    @click="clickItemAction(item, index, menu.action)"
                  >
                    <v-list-tile-title>{{ menu.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
      <!--PUSH-->
      <v-flex xs12 :class="!pushs.length ? '' : 'mb-4'" v-if="approach.type == 'PUSH'">
        <h2 v-if="!pushs.length" class="text-xs-center font-weight-regular">
          Nenhum push cadastrado.
        </h2>
        <v-list three-line subheader>
          <v-list-tile v-for="(item, index) in pushs" :key="index" class="item-content">
            <v-list-tile-content>
              <div class="font-weight-bold">{{ item.title }}</div>
              <div>{{ item.body }}</div>

              <div v-if="item.offer_type" class="item-offer-type">
                Tipo da Oferta:
                <span class="item-offer-type-description">
                  {{ item.offer_type.description }}
                </span>
              </div>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn ripple icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(menu, i) in menuItens"
                    :key="i"
                    @click="clickItemAction(item, index, menu.action)"
                  >
                    <v-list-tile-title>{{ menu.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
      <!--EMAIL-->
      <v-flex
        xs12
        :class="!emails.length ? '' : 'mb-4'"
        v-if="approach.type == 'EMAIL' || approach.type == 'EMAIL_TEXT'"
      >
        <h2 v-if="!emails.length" class="text-xs-center font-weight-regular">
          Nenhum e-mail cadastrado.
        </h2>
        <v-list three-line subheader>
          <v-list-tile v-for="(item, index) in emails" :key="index" class="item-content">
            <v-list-tile-content>
              <v-layout class="pa-0 ma-0" justify-space-between align-center row wrap>
                <div class="font-weight-bold">{{ item.subject }}</div>
                <div class="ml-5">
                  <a :href="item.template_url" target="_blank">
                    {{ item.template_url }}
                  </a>
                </div>
              </v-layout>

              <div v-if="item.offer_type" class="item-offer-type">
                Tipo da Oferta:
                <span class="item-offer-type-description">
                  {{ item.offer_type.description }}
                </span>
              </div>

              <iframe
                class="pa-0 ma-0"
                v-if="item.content"
                :srcdoc="item.content"
                scrolling="no"
                height="30"
                frameBorder="0"
                width="100%"
                src="demo_iframe_srcdoc.htm"
              ></iframe>
              <v-layout row wrap> </v-layout>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn ripple icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(menu, i) in menuItens"
                    :key="i"
                    @click="clickItemAction(item, index, menu.action)"
                  >
                    <v-list-tile-title>{{ menu.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-btn color="accent" fixed bottom right fab @click="dialog = true">
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog
      scrollable
      persistent
      max-width="80vw"
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ approachType.name }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0" style="height: 80vh">
          <v-layout wrap>
            <!--SMS-->
            <v-flex xs12 v-if="approach.type == 'SMS_FLASH'">
              <v-alert v-model="alert" dismissible type="warning">
                Abordagens do tipo sms_flash não abrem links.
              </v-alert>
            </v-flex>
            <v-flex xs12 v-if="approach.type == 'SMS' || approach.type == 'SMS_FLASH'">
              <textAreaAutocomplete
                name="sms"
                label="Conteúdo"
                :message="message"
                :variables="variables"
                @message="message = $event"
              />
              <small>
                <div class="text-xs-right" style="padding: 4px">
                  <strong>{{ contentLength + "/160 " + caracterLabel }}</strong>
                </div>
              </small>
            </v-flex>
            <!--SMS-->
            <!--PUSH-->
            <v-flex xs12 class="mb-3" v-if="approach.type == 'PUSH'">
              <v-text-field
                box
                required
                hide-details
                class="green-input"
                v-model="push.title"
                value="Novo push"
                label="Título*"
                name="push_title"
              />
            </v-flex>
            <v-flex xs12 class="mb-3" v-if="approach.type == 'PUSH'">
              <v-select
                box
                required
                hide-details
                label="Link*"
                :items="links"
                v-model="push.link"
              ></v-select>
            </v-flex>
            <v-flex xs12 class="mb-3" v-if="approach.type == 'PUSH'">
              <textAreaAutocomplete
                name="body"
                label="Conteúdo*"
                :message="push.body"
                :variables="variables"
                @message="push.body = $event"
              />
            </v-flex>
            <!--PUSH-->
            <!--EMAIL-->
            <v-flex
              xs12
              class="mb-3"
              v-if="approach.type == 'EMAIL' || approach.type == 'EMAIL_TEXT'"
            >
              <v-text-field
                box
                required
                hide-details
                name="email_subject"
                label="Assunto do email*"
                v-model="email.subject"
              />
            </v-flex>
            <v-flex
              xs12
              class="mb-3"
              v-if="approach.type == 'EMAIL' || approach.type == 'EMAIL_TEXT'"
            >
              <v-text-field
                box
                required
                hide-details
                type="url"
                size="100"
                name="url_email"
                label="Url do email*"
                v-model="email.template_url"
              >
                <template v-slot:append>
                  <v-icon
                    color="primary"
                    :disabled="!isValidHttpUrl(email.template_url)"
                    @click="window.open(`${email.template_url}`, '_blank')"
                    >mdi-code-tags</v-icon
                  >
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 class="mb-3" v-if="approach.type == 'EMAIL_TEXT'">
              <vue-mce ref="tynyMce" v-model="email.content" :config="configMce" />
            </v-flex>
            <!--EMAIL-->
            <v-flex xs12>
              <v-switch
                hide-details
                class="mb-1 mt-0 pt-0"
                label="Mostrar mais variáveis"
                v-model="switchShow"
              ></v-switch>
            </v-flex>
            <!--VARIABLES-->
            <v-flex md12 class="mb-3" style="overflow: auto; border: 1px solid #cccccc">
              <v-layout
                wrap
                align-left
                justify-left
                class="var_container"
                :data-select="variableSelected"
              >
                <v-flex
                  lg3
                  md4
                  sm6
                  xs12
                  :key="`${k}`"
                  v-for="(variable, k) in variables"
                  v-show="switchShow ? true : variable.show"
                >
                  <v-chip
                    class="var_content"
                    :disabled="variable.selected"
                    v-on:click="varClick(variable.name)"
                  >
                    <small>
                      <strong>{{ variable.name }}</strong>
                      <br />
                      <small style="margin-top: -2px; font-size: 10px">
                        {{ variable.label }}
                      </small>
                    </small>
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-flex>
            <!--VARIABLES-->
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="pa-2" row wrap>
            <v-select
              box
              clearable
              hide-details
              item-value="id"
              label="Tipo da oferta"
              item-text="description"
              :items="offerTypes"
              v-model="offerId"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn
              large
              outline
              color="primary"
              style="margin-top: 6px"
              @click="dialog = false"
            >
              Fechar
            </v-btn>
            <v-btn
              large
              color="primary"
              class="elevation-0"
              style="margin-top: 6px"
              :disabled="!contentValid"
              @click="editItem ? updateData() : addData()"
            >
              Salvar
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" persistent width="400">
      <v-card>
        <v-card-text style="height: 100px">
          <h2 class="text-xs-center mt-4">Tem certeza que quer excluir?</h2>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="removeData()"> Sim </v-btn>
          <v-btn color="green" dark @click="dialogConfirm = false"> Não </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-snackbar v-model="show_snack" :timeout="0" :top="true">
      {{snack_text}}
      <v-btn flat icon color="error" @click.stop="show_snack = false">
          <v-icon>mdi-close</v-icon>
      </v-btn>
  </v-snackbar>

  </v-container>
</template>

<script>
import store from "@/store";
import offerService from "@/services/offer";
import approachType from "@/utils/approach-type";
import approachService from "@/services/approach";
import creditorService from "@/services/creditor";
import textAreaAutocomplete from "@/components/TextAreaAutocomplete";
import variables from "@/utils/message-variables";

export default {
  props: ["approach_id"],
  components: {
    textAreaAutocomplete,
  },
  data: () => ({
    show_snack: false,
    snack_text:"",
    alert: true,
    dialog: false,
    editItem: false,
    switchShow: false,
    dialogConfirm: false,
    offerId: null,
    contentLength: 0,
    message: "",
    pushs: [],
    emails: [],
    messages: [],
    offerTypes: [],
    variables_array: [],
    links: ["$LINK", "$LINK_REDIRECT", "$LINK_WHATSAPP", "$LINK_FOMENTATION", "$LINK_ME_LEMBRE"],
    notifyTypes: [
      { value: "SEQUENTIAL", name: "Sequencial" },
      { value: "RANDOM", name: "Aleatória" },
    ],
    menuItens: [
      {
        label: "Editar",
        action: "edit",
      },
      {
        label: "Excluir",
        action: "delete",
      },
    ],
    waitingToBeDeleted: null,
    currentEditItemIndex: null,
    approachType: {
      name: "",
      color: "",
      value: "",
    },
    creditors: {
      objects: [],
    },
    approach: {
      name: "",
      creditor_id: "",
      notify_type: "",
    },
    configMce: {
      language: "pt_BR",
      height: "250",
      branding: false,
      language_url: "tinymce-language-pt_BR.js",
      theme: "modern",
      fontsize_formats: "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 39px 34px",
      plugins: "preview fullpage searchreplace autolink",
      toolbar1:
        "formatselect fontsizeselect | bold italic strikethrough forecolor backcolor link",
    },
    push: {
      body: "",
      title: "",
      link: "$LINK",
    },
    email: {
      content: "",
      subject: "",
      template_url: "",
    },
  }),
  async created() {
    await this.getCreditors();
    await this.getOfferType();
    await this.getApproach();
    
    this.variables_array = variables.variables;
    let query = store.getters.getApproachesFilters || {};
    let approachsTypes = approachType.approachType.map((e) => e);
    if (this.approach.type) {
      this.approachType = approachsTypes.find((e) => e.value === this.approach.type);
    } else {
      this.approachType = Object.assign({}, this.approachTypeProp);
      this.approach.type = this.approachTypeProp.value;
    }
    if (query.creditor && !this.approach.creditor_id)
      this.approach.creditor_id = query.creditor;
    this.loadDataField();
  },
  computed: {
    isValidForm() {
      let valid = true;
      if (!this.approach.name) valid = false;
      if (!this.approach.creditor_id) valid = false;
      return valid;
    },
    caracterLabel() {
      if (this.message.length == 0) {
        return "caracteres";
      } else {
        return "caracteres";
      }
    },
    contentValid() {
      let valid = false;
      let array_variables = this.variables
      array_variables = array_variables.map(variable => String(variable.name))
      if (this.approach.type == "SMS" || this.approach.type == "SMS_FLASH") {
        this.contentLength = this.message.length;
        if (this.message == "") return false;
        if (this.message.includes(" $ ")) return false;
        if (!this.message.match(/\$LINK[A-Z_0-9]*/)) return false;

        let v = this.message.matchAll(/^\$([A-Z_0-9]*)/g)
        v = Array.from(v)
        v = v.map(x => x[0])
        for (const idx in v) {
            if ((!array_variables.includes(v[idx]) || v[idx] == "$")) {
              this.snack_text = `O campo ${v[idx]} foi encontrado porém não é uma variável permitida!`
              this.show_snack = true
              return false
            }
        }
        
        for (const idx in array_variables) {
          let u = this.message.includes(array_variables[idx].replace("$", " "))
          let w = !this.message.includes(array_variables[idx])
          if (this.message.includes(array_variables[idx].replace("$", " ")) && !this.message.includes(array_variables[idx])) {
            this.snack_text = `Possível variável ${array_variables[idx]} encontrada, porém digitada incorretamente!`  
            this.show_snack = true
            return false
          };
        }

        let message = this.message;
        this.variables.forEach((e) => {
          if (message.includes(e.name)) {
            let randomString = Math.random().toString(2).substring(0, e.length);
            message = message.replace(e.name, randomString);
            this.contentLength = message.length;
          }
        });
        if (this.contentLength <= 160) valid = true;
      }
      if (this.approach.type == "PUSH") {
        if (
          this.push.body &&
          this.push.title &&
          this.push.body.length > 0 &&
          this.push.title.length > 0
        )
          valid = true;
      }
      if (this.approach.type == "EMAIL_TEXT" || this.approach.type == "EMAIL") {
        if (
          this.email.subject &&
          this.email.subject.length > 0 &&
          this.isValidHttpUrl(this.email.template_url)
        )
          valid = true;
      }
      this.show_snack = false
      return valid;
    },
    variableSelected() {
      let vm = this;
      if (vm.approach.type == "SMS" || this.approach.type == "SMS_FLASH") {
        let message = this.message;
        for (let i = 0; i < vm.variables.length; i++) {
          if (message.includes(vm.variables[i].name)) {
            let randomString = Math.random()
              .toString(2)
              .substring(0, vm.variables[i].length);
            message = message.replace(vm.variables[i].name, randomString);
            vm.variables[i]["selected"] = true;
          } else {
            vm.variables[i]["selected"] = false;
          }
        }
      } else {
        return false;
      }
    },
    variables() {
      if (!this.approach.creditor_id || !this.creditors.objects.length) return [];

      let allowed_variables = (
        this.creditors.objects.find((c) => c.creditor_id == this.approach.creditor_id)
          .allowed_variables || []
      );
      
      if (!allowed_variables.length) 
        return this.variables_array

      return this.variables_array.filter(item => allowed_variables.includes(item.name));

    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        setTimeout(() => {
          this.offerId = null;
          this.message = "";
          this.push.body = "";
          this.push.title = "";
          this.push.link = "$LINK";
          this.email.content = "";
          this.email.subject = "";
          this.email.template_url = "";
          this.alert = true;
          this.editItem = false;
        }, 500);
      }
    },
  },
  methods: {
    async getCreditors() {
      await creditorService
        .list()
        .then((res) => (this.creditors = res))
        .catch((err) => console.error(err));
    },
    async getOfferType() {
      await offerService
        .list()
        .then((res) => (this.offerTypes = res))
        .catch((err) => console.error(err));
    },
    async getApproach() {
      await approachService
        .findById(this.approach_id)
        .then((res) => (this.approach = res))
        .catch((err) => console.error(err));
    },
    async loadDataField() {
      if (this.approach.messages) {
        if (
          (this.approach.type == "SMS" || this.approach.type == "SMS_FLASH") &&
          this.approach.messages
        ) {
          this.messages = this.approach.messages;
        } else if (this.approach.type == "PUSH") {
          this.pushs = this.approach.messages;
        } else if (this.approach.type == "EMAIL_TEXT" || this.approach.type == "EMAIL") {
          this.emails = this.approach.messages;
        }
      }
    },
    save() {
      if (!this.$refs.form.validate()) return;

      approachService
        .save({
          id: this.approach.id,
          name: this.approach.name,
          creditor_id: this.approach.creditor_id,
          notify_type: this.approach.notify_type,
        })
        .then((res) => {
          if (res == undefined) {
            console.error("houve um erro");
            this.$store.commit("showSnackbar", {
              message: "Houve um erro ao salvar",
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: "Abordagem salva com sucesso!",
              important: true,
            });
            this.approach = res;
          }
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao salvar",
          });
        });
    },
    varClick(value) {
      if (this.approach.type == "SMS" || this.approach.type == "SMS_FLASH") {
        if (this.message != "") {
          if (this.message[this.message.length - 1] != " ") {
            value = " " + value;
          }
        }
        this.message += value;
      } else if (this.approach.type == "PUSH") {
        this.push.body = this.push.body + " " + value;
      } else if (this.approach.type == "EMAIL") {
        this.email.subject = this.email.subject + " " + value;
      } else if (this.approach.type == "EMAIL_TEXT") {
        let content = this.email.content;
        let index = content.indexOf("</body>");
        let text =
          content.slice(0, index) + "<p>" + value + "</p>" + content.slice(index);
        tinymce.activeEditor.setContent(text);
        // this.email.text = this.email.text + " " + value;
      }
    },
    addData() {
      let type = "";
      let item = {};
      let payload = {};
      if (this.approach.type == "SMS" || this.approach.type == "SMS_FLASH") {
        type = "sms";
        payload = {
          approach_id: parseInt(this.approach_id),
          content: this.message.trim(),
          flash: this.approach.type == "SMS_FLASH" ? true : false,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.approach.type == "PUSH") {
        type = "push";
        item = Object.assign({}, this.push);
        payload = {
          approach_id: parseInt(this.approach_id),
          title: item.title.trim(),
          body: item.body.trim(),
          link: item.link,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else {
        type = "email";
        item = Object.assign({}, this.email);
        payload = {
          approach_id: parseInt(this.approach_id),
          subject: item.subject.trim(),
          template_url: item.template_url.trim(),
          content: item.content.trim(),
          offer_type_id: this.offerId ? this.offerId : null,
        };
      }
      approachService[type](payload)
        .then((resp) => {
          this.approach.messages.push(resp);
          this.dialog = false;
          this.loadDataField();
        })
        .catch((err) => {
          console.error(err);
          alert("Não foi possível salvar a mensagem");
        });
    },
    updateData() {
      let type = "";
      let array = "";
      let item = {};
      let payload = {};
      let tempCurrentEditItemIndex = this.currentEditItemIndex;

      if (this.approach.type == "SMS" || this.approach.type == "SMS_FLASH") {
        type = "sms";
        array = "messages";
        payload = {
          approach_id: parseInt(this.approach_id),
          content: this.message,
          flash: this.approach.type == "SMS_FLASH" ? true : false,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.approach.type == "PUSH") {
        item = Object.assign({}, this.push);
        type = "push";
        array = "pushs";
        payload = {
          approach_id: parseInt(this.approach_id),
          title: item.title.trim(),
          body: item.body.trim(),
          link: item.link,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else {
        item = Object.assign({}, this.email);
        type = "email";
        array = "emails";
        payload = {
          approach_id: parseInt(this.approach_id),
          subject: item.subject.trim(),
          template_url: item.template_url.trim(),
          content: item.content.trim(),
          offer_type_id: this.offerId ? this.offerId : null,
        };
      }
      approachService[type](payload, this[array][tempCurrentEditItemIndex].id)
        .then((resp) => {
          this.approach.messages.forEach((item, index) => {
            if (item.id == this[array][tempCurrentEditItemIndex].id) {
              this.approach.messages[index] = Object.assign(item, resp);
              this[array][tempCurrentEditItemIndex] = this.approach.messages[index];
            }
          });

          this.dialog = false;
          this.currentEditItemIndex = null;
        })
        .catch((err) => {
          console.error(err);
          alert("Não foi possível salvar a mensagem");
        });
    },
    clickItemAction(item, itemIndex, action) {
      if (action == "delete") {
        this.waitingToBeDeleted = {
          index: itemIndex,
          item: item,
        };
        this.dialogConfirm = true;
      } else {
        this.editData(item, itemIndex);
      }
    },
    editData(item, itemIndex) {
      if (this.approach.type == "SMS" || this.approach.type == "SMS_FLASH") {
        this.message = item.content;
        this.offerId = item.offer_type_id;
      } else if (this.approach.type == "PUSH") {
        this.push = Object.assign({}, item);
        this.offerId = item.offer_type_id;
      } else {
        this.email = Object.assign({}, item);
        this.offerId = item.offer_type_id;
      }
      this.dialog = true;
      this.editItem = true;
      this.currentEditItemIndex = itemIndex;
    },
    removeData() {
      let type = "";
      let array = "";
      if (this.approach.type == "SMS" || this.approach.type == "SMS_FLASH") {
        type = "sms";
        array = "messages";
      } else if (this.approach.type == "PUSH") {
        type = "push";
        array = "pushs";
      } else {
        type = "email";
        array = "emails";
      }
      approachService[type](null, this.waitingToBeDeleted.item.id)
        .then(
          () =>
            (this[array] = this[array].filter(
              (e, i) => i !== this.waitingToBeDeleted.index
            ))
        )
        .catch((err) => {
          console.error(err);
          alert("Não foi possível excluir a mensagem");
        });
      this.dialogConfirm = false;
    },
    comeBack() {
      this.$router.go(-1);
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
  },
};
</script>

<style>
.item-content {
  margin: 10px 0px;
  padding: 5px 2px;
  border-color: #d3d3d3;
  border-style: dashed;
  border-width: 2px;
  border-radius: 10px;
}

.var_content {
  border-radius: 12px;
  padding: 2px 0px;
}

.var_container {
  max-height: 600px;
  overflow: auto;
}

.item-offer-type {
  color: gray;
  font-size: 14px;
  margin-top: 4px;
}

.item-offer-type-description {
  font-weight: 500;
}
</style>
